import React, { FC, HTMLProps } from 'react';
import { ReactComponent as CheckIcon } from 'assets/icons_3/check-small.svg';
import classNames from 'classnames';
import styles from './ValidationCheck.module.scss';

interface ValidationCheckProps extends HTMLProps<HTMLDivElement> {
  checked: boolean
  label?: string
}

const ValidationCheck: FC<ValidationCheckProps> = ({
  checked, label, className, ...props
}) => (
  <div
    className={classNames(styles.check, className, {
      [styles.checked]: !!checked,
    })}
    {...props}
  >
    <div className={styles.icon}>
      <CheckIcon />
    </div>
    <span>{label}</span>
  </div>
);

export default ValidationCheck;
